import { RichTextInput } from "ra-input-rich-text";
import React from "react";
import { BooleanInput, Create, SimpleForm, TextInput } from "react-admin";
import { FileInput } from "../fileinputs/eventFileUpload";

export function InAppAdsCreate(props) {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="title" fullWidth />
        <RichTextInput source="description" fullWidth />
        <TextInput source="link" fullWidth />
        <FileInput
          title="Banner Image"
          add
          edit
          source={"adBannerImage"}
          route="inappAds/upload"
        />
        <FileInput
          title="Carousel Images"
          add
          edit
          source={"images"}
          route="inappAds/upload"
        />
        <BooleanInput source="isActive" />
        <BooleanInput source="directRedirection" />
      </SimpleForm>
    </Create>
  );
}
